import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/education-icon.svg'


const _hoisted_1 = { class: "d-flex ga-5" }
const _hoisted_2 = { class: "d-flex flex-column ga-1 w-100" }
const _hoisted_3 = { class: "d-flex justify-space-between w-100 align-center" }
const _hoisted_4 = { class: "d-flex ga-2" }
const _hoisted_5 = { class: "f-body-1" }
const _hoisted_6 = { class: "f-body-1 mt-5" }
const _hoisted_7 = { class: "f-body-1 mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "b-dark education-item" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("div", null, [
              _createElementVNode("img", {
                class: "item-card-icons",
                src: _imports_0
              })
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.education.University), 1),
                _createElementVNode("div", _hoisted_4, [
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        icon: "mdi-pen",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.edit
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true),
                  (!_ctx.isHiringmanager)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        icon: "mdi-delete",
                        class: "c-black b-white",
                        disabled: _ctx.loading,
                        onClick: _ctx.remove
                      }, null, 8, ["disabled", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.education.Degree) + " - " + _toDisplayString(_ctx.truncate(_ctx.education.StudyField, 30)), 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.education.Description ? _ctx.education.Description : "-"), 1),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.education.StartDate ? _ctx.formatDate(_ctx.education.StartDate) : "") + " " + _toDisplayString(_ctx.education.EndDate ? " - " + _ctx.formatDate(_ctx.education.EndDate) : "") + " " + _toDisplayString(_ctx.education.StillStudying ? (_ctx.education.StartDate || _ctx.education.EndDate ? " - Still Studying" : "Still Studying") : ""), 1)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}